import { ResponsiveOrdinalFrame } from "semiotic";
import type { LensStats } from "./types";

const labels = ["Under $1m", "$1–3m", "$3–5m", "$5–15m", "$15–25m", "$25m+"];
const colors = ["#9a9281", "#f6c85f", "#f39b42", "#ec6a4d", "#d63d48", "#8f1735"];

export function LensChart({ stats }: { stats: LensStats }) {
  const data = labels.map((label, index) => ({
    label,
    value: stats.bands[index],
    color: colors[index]
  }));

  return (
    <div className="chart-wrap" aria-label="Value bands for roll rows under the spotlight">
      <ResponsiveOrdinalFrame
        size={[360, 174]}
        responsiveWidth
        data={data}
        oAccessor="label"
        rAccessor="value"
        type="bar"
        projection="horizontal"
        margin={{ top: 4, right: 12, bottom: 24, left: 74 }}
        style={(datum: { color: string }) => ({
          fill: datum.color,
          stroke: "#171610",
          strokeWidth: 1
        })}
        axes={[
          {
            orient: "bottom",
            tickFormat: (value: number) => (value === 0 ? "0" : `${value / 1000}k`)
          }
        ]}
        oLabel
        tooltipContent={(datum: { label: string; value: number }) => (
          <div className="chart-tooltip">
            <strong>{datum.label}</strong>
            <span>{datum.value.toLocaleString()} rows</span>
          </div>
        )}
        hoverAnnotation
      />
    </div>
  );
}
